import React, { Component } from 'react';
import './Header.css'

class Header extends Component {
    render() {
        return (
            <section class="category_banner">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 category_bannertext">
                            <h1>Flash Delivery</h1>
                            <p>Our work is honed by years of experience and tremendous support from external experts. We work at a pace and energy level unmatched by any other in the industry. The flash delivery service is customized for several of your immediate data needs such as consultants with a 12-hour deadline, managers who need market estimates for the next-day meeting, business information snapshot for a quick look, etc. Our research support is available round the clock.</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }


}


export default Header;


// WEBPACK FOOTER //
// ./src/consulting/FlashDelivery/Header/Header.js